var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99654 18.7071C7.60602 18.3166 7.60602 17.6834 7.99654 17.2929L13.2894 12L7.99654 6.70711C7.60602 6.31658 7.60602 5.68342 7.99654 5.29289C8.38707 4.90237 9.02023 4.90237 9.41076 5.29289L15.234 11.1161C15.7221 11.6043 15.7221 12.3957 15.234 12.8839L9.41076 18.7071C9.02023 19.0976 8.38707 19.0976 7.99654 18.7071Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.10014fc3d4ba1b10da7a58b3bab58eca.svg";
export { ForwardRef as ReactComponent };